import { render, staticRenderFns } from "./PickLabelDetail.vue?vue&type=template&id=e219ff78&scoped=true"
import script from "./PickLabelDetail.vue?vue&type=script&lang=js"
export * from "./PickLabelDetail.vue?vue&type=script&lang=js"
import style0 from "./PickLabelDetail.vue?vue&type=style&index=0&id=e219ff78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e219ff78",
  null
  
)

export default component.exports